import "./App.css";
import Homepage from "./pages/Homepage";
import Contactpage from "./pages/Contactpage";
import Aboutpage from "./pages/Aboutpage";
import Servicepage from "./pages/Servicepage";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { PropagateLoader } from "react-spinners";
import { useEffect, useState } from "react";
import ScrollToTop from "./pages/ScrollToTop";
import { AssetLoader } from "./assets/assets";

function App() {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 3000);
  }, []);

  return (
    <>
      {loading ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100vw",
            height: "100vh",
            overflow: "hidden",
            backgroundColor: "#000000",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div className="loader-container">
            <h1
              style={{
                color: "#c89116",
                fontSize: "1rem",
                marginBottom: "1.5rem",
              }}
            >
              B.P. Alloys Limited
            </h1>
          </div>
          <PropagateLoader color={"#c89116"} loading={loading} />
        </div>
      ) : (
        <Router>
          <ScrollToTop />
          <AssetLoader />
          <Routes>
            <Route element={<Homepage />} path="/" />
            <Route element={<Contactpage />} path="/contact" />
            <Route element={<Aboutpage />} path="/about" />
            <Route element={<Servicepage />} path="/service" />
          </Routes>
        </Router>
      )}
    </>
  );
}

export default App;
